import { Spin } from "antd";
import DeleteThinIcon from "components/Icons/DeleteThinIcon";
import EditDropIcon from "components/Icons/EditDropIcon";
import { TableCardStyle } from "components/TableCard/TableCard.style";
import { ContactListType } from "components/fax/Contacts";
import { Button } from "components/ui-component";

interface ContactCardDataProps {
  contactCardData: ContactListType[];
  isLoading: boolean;
  editContact: (contact: ContactListType) => void;
  deleteContact: (contactId: string) => void;
}

const ContactsTableCard = ({
  contactCardData,
  isLoading,
  editContact,
  deleteContact,
}: ContactCardDataProps) => {
  return (
    <>
      {isLoading ? (
        <Spin className="loading-spinner" />
      ) : (
        contactCardData?.length > 0 &&
        contactCardData?.map((contact) => (
          <TableCardStyle key={contact?.contact_id}>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <div className="to-number capitalize">
                {" "}
                {`${contact?.firstname} ${contact?.lastname}`}
              </div>
            </div>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <div className="date">{contact?.fax_number}</div>
            </div>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <div className="notes">
                {contact?.notes || "No notes for this contact."}
              </div>
            </div>
            <div className="d-flex font-14 justify-content-between align-item-center">
              <Button
                type="text"
                className="d-flex gap-2 edit font-14 priamry-btntext"
                onClick={() => {
                  editContact(contact);
                }}
              >
                <EditDropIcon />
                Edit
              </Button>

              {contact?.contact_source !== "external" && (
                <Button
                  type="text"
                  className="d-flex gap-2 delete font-14 "
                  onClick={() => {
                    deleteContact(contact?.contact_id);
                  }}
                >
                  <DeleteThinIcon width="14" height="14" strokeWidth="2" />
                  Delete
                </Button>
              )}
            </div>
          </TableCardStyle>
        ))
      )}
    </>
  );
};

export default ContactsTableCard;
